import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT, DELETE, ADD } from "const"
import { okrSessionsRoute } from "client/parts/routes"
import { hasAccess } from "client/utils"
import {
    PRM_OKR_SESSION,
    PRM_OKR_OBJECTIVE_KEY_RESULT,
    StoreType,
    setOkrSessionPopupMenuShow,
    setOkrSessionShowConfirmDelete,
    addModal,
} from "client/store"
import {
    PopupMenu,
    PopupMenuItem,
} from "client/components"

const Menu = () => {
    const activeSession = useSelector((state: StoreType) => state.okrSession.active)
    const menuShow = useSelector((state: StoreType) => state.okrSession.menuShow)
    const menuTarget = useSelector((state: StoreType) => state.okrSession.menuTarget)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const hideMenu = () => {
        dispatch(setOkrSessionPopupMenuShow(false))
    }

    useEffect(() => {
        document.addEventListener("click", hideMenu)
        return () => document.removeEventListener("click", hideMenu)
    }, [])

    const addOkrAccess = hasAccess(PRM_OKR_OBJECTIVE_KEY_RESULT, ADD)
    const editAccess = hasAccess(PRM_OKR_SESSION, EDIT)
    const deleteAccess = hasAccess(PRM_OKR_SESSION, DELETE)

    if (!activeSession) return null

    const isOwner = activeSession.owner === userData.userId
    const editUrl = `${okrSessionsRoute}/${EDIT}/${activeSession.id}`

    return (
        <PopupMenu
            show={menuShow}
            target={menuTarget}
            placement="right"
        >
            {
                (editAccess || isOwner) && (
                    <PopupMenuItem onClick={() => dispatch(addModal({ url: editUrl }))}>
                        {lang.edit}
                    </PopupMenuItem>
                )
            }
            {
                addOkrAccess && (
                    <PopupMenuItem>
                        {lang.copyOkrsIn}
                        TODO
                    </PopupMenuItem>
                )
            }
            <PopupMenuItem>
                {lang.overview}
                TODO
            </PopupMenuItem>
            {
                (deleteAccess || isOwner) && (
                    <PopupMenuItem onClick={() => dispatch(setOkrSessionShowConfirmDelete(true))}>
                        {lang.delete}
                    </PopupMenuItem>
                )
            }
        </PopupMenu>
    )
}

export default Menu
